import i18n from 'i18n-react';
import remarkGfm from 'remark-gfm';
import type { RagLink } from './types';

export const RECENT_PORTAL_LIMIT = 3;
export const QUICK_SUGGESTION_COUNT = 2;

// ─── Suggestions ───────────────────────────────────────────────────────────

export const getFallbackSuggestions = (): string[] => [
  i18n.translate('smartAssist.fallbackSuggestions.bestBeaches') as string,
  i18n.translate('smartAssist.fallbackSuggestions.familyActivities') as string,
  i18n.translate('smartAssist.fallbackSuggestions.hiddenGems') as string,
  i18n.translate('smartAssist.fallbackSuggestions.roadTrips') as string,
  i18n.translate('smartAssist.fallbackSuggestions.dining') as string,
  i18n.translate('smartAssist.fallbackSuggestions.events') as string,
];

export const sliceSuggestionPair = (list: string[], pairIndex: number, pairSize: number): string[] => {
  if (!list.length) return [];
  const size = Math.max(1, pairSize);
  const numPairs = Math.ceil(list.length / size);
  const safeIdx = ((pairIndex % numPairs) + numPairs) % numPairs;
  return list.slice(safeIdx * size, safeIdx * size + size);
};

export const randomizeSuggestionList = (list: string[]): string[] => {
  const shuffled = [...list];
  for (let i = shuffled.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

export const canRotateSuggestionPairs = (list: string[], pairSize: number): boolean =>
  list.length > pairSize;

// ─── Display helpers ────────────────────────────────────────────────────────

export const ragLinkLabel = (link: RagLink): string => {
  const { cms = {}, kind, title } = link;
  const fromApi = (typeof title === 'string' && title.trim()) || (typeof cms.title === 'string' && cms.title.trim());
  if (fromApi) return fromApi;
  if (cms.item_type) return cms.item_type.replace(/_/g, ' ');
  if (kind) return kind.replace(/_/g, ' ');
  return i18n.translate('smartAssist.sourceFallback') as string;
};

export const threadIdPreview = (uuid: string): string => {
  if (!uuid || uuid.length <= 12) return uuid;
  return `${uuid.slice(0, 8)}…`;
};

export const linkOpensNewTab = (href: string | undefined): boolean =>
  Boolean(href && !href.trimStart().toLowerCase().startsWith('javascript:'));

export const remarkMarkdownPlugins = [remarkGfm];
